import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Hireform() {
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState('');

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        apply: '',
        file: null,
        experience: '',
        mobile: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        const newValue = type === 'file' ? files[0] : value;
        setFormData(prevData => ({
            ...prevData,
            [name]: newValue
        }));

        if (type === 'file') {
            setFileName(files[0] ? files[0].name : '');
            return;
        }

        // Check if input field is filled and add class accordingly
        const parent = e.target.parentNode;
        if (value.trim() !== '') {
            parent.classList.add('filled');
            parent.classList.remove('error');
        } else {
            parent.classList.remove('filled');
        }
    };

    const [errors, setErrors] = useState({});

    const handleFocus = (e) => {
        e.target.parentNode.classList.add('focus');
    };

    const handleBlur = (e) => {
        e.target.parentNode.classList.remove('focus');
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const errors = {};
        if (formData.name.trim() === '') {
            errors.name = 'Person Name is required';
        }
        if (formData.apply.trim() === '') {
            errors.apply = 'Apply Data is required';
        }
        if (formData.email.trim() === '') {
            errors.email = 'Email is required';
        } else if (!isValidEmail(formData.email)) {
            errors.email = 'Invalid email format';
        }

        if (formData.mobile.trim() === '') {
            errors.mobile = 'Mobile Number is required';
        } else if (!isValidPhoneNumber(formData.mobile)) {
            errors.mobile = 'Invalid mobile number format';
        }

        if (formData.experience.trim() === '') {
            errors.experience = 'Experience is required';
        }

        if (!formData.file) {
            errors.file = 'File is required';
        }

        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }

        const formDataToSend = new FormData();
        for (let key in formData) {
            formDataToSend.append(key, formData[key]);
        }

        fetch('https://thespinnennetz.com/sn-forms/hire.php', {
            method: 'POST',
            body: formDataToSend,
        })
            .then(response => {
                // if (!response.ok) {
                //     throw new Error('Network response was not ok');
                // }
                console.log('Form submitted successfully', response);
                setFormData({
                    name: '',
                    email: '',
                    apply: '',
                    file: '',
                    experience: '',
                    mobile: '',
                    message: ''
                });
                navigate("/thank-you-careers");
            })
            .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
    };

    const isValidPhoneNumber = (phoneNumber) => {
        // Basic phone number validation (digits only, at least 7 digits)
        const re = /^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/;
        return re.test(phoneNumber);
    };

    const isValidEmail = (email) => {
        // Basic email validation
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    return (
        <>
            <div className="form-section contact cSection">
                <div className="cContainer">
                    <div className="sn-form-outer">
                        <h3>APPLY HERE</h3>
                        <form className="sn-form-grid" onSubmit={handleSubmit} encType="multipart/form-data">
                            <div className={`sn-floating-group sn-half ${errors.name ? 'error' : ''} ${formData.name ? 'filled' : ''}`}>
                                <input type="text" name="name" className="sn-form-control" value={formData.name} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Contact Person Name</label>
                                {errors.name && <span className="sn-err">{errors.name}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.email ? 'error' : ''} ${formData.email ? 'filled' : ''}`}>
                                <input type="email" name="email" className="sn-form-control" value={formData.email} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Email Address</label>
                                {errors.email && <span className="sn-err">{errors.email}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.apply ? 'error' : ''} ${formData.apply ? 'filled' : ''}`}>
                                <input type="text" name="apply" className="sn-form-control" value={formData.apply} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Apply For</label>
                                {errors.apply && <span className="sn-err">{errors.apply}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half sn-file-group ${errors.file ? 'error' : ''}`}>
                                <input
                                    type="file"
                                    name="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleChange}
                                />
                                <div
                                    className={`sn-custom-file-btn ${errors.file ? 'error' : ''}`}
                                    onClick={() => fileInputRef.current.click()}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <div className="sn-file-text">
                                        <span className="sn-file-title">{fileName || 'Upload Resume'}</span>
                                        <span className="sn-file-subtitle">{fileName ? 'File selected ✓' : 'PDF, DOC, DOCX (Max 5MB)'}</span>
                                    </div>
                                </div>
                                {errors.file && <span className="sn-err">{errors.file}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.experience ? 'error' : ''} ${formData.experience ? 'filled' : ''}`}>
                                <input type="text" name="experience" className="sn-form-control" value={formData.experience} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Experience</label>
                                {errors.experience && <span className="sn-err">{errors.experience}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.mobile ? 'error' : ''} ${formData.mobile ? 'filled' : ''}`}>
                                <input type="tel" name="mobile" className="sn-form-control" value={formData.mobile} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Mobile</label>
                                {errors.mobile && <span className="sn-err">{errors.mobile}</span>}
                            </div>
                            <div className={`sn-floating-group sn-full ${errors.message ? 'error' : ''} ${formData.message ? 'filled' : ''}`}>
                                <textarea name="message" className="sn-form-control sn-textarea" value={formData.message} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Message</label>
                            </div>
                            <button type="submit" className="sn-submit-btn sn-full">
                                Submit <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
